import { selectize } from "@selectize/selectize";
import { Fancybox } from "@fancyapps/ui";
import { Splide } from "@splidejs/splide";

// OCRE custom components
import { MainMenuJS } from "./components/main-menu";
import { OCFirstLogin } from "./components/oc-first";
import {
  overrideMap,
  mapcluster,
  mapcluster_hostaway
} from "./components/oc-components";
import {
  initializeEngagementForm,
  engagementToolTabTitles
} from "./components/customer-engagement-tool";

// MAIN Content Loaded file
window.addEventListener("DOMContentLoaded", function (e) {
  // Load main menu behaviour and properties
  MainMenuJS();
  OCFirstLogin();
  initializeEngagementForm();
  engagementToolTabTitles();
});

// Add map cluster to global
window.mapcluster = mapcluster;
window.mapcluster_hostaway = mapcluster_hostaway;
window.Splide = Splide;

// MAIN Scroll Event listener
window.addEventListener("scroll", function (e) { });

window.autocomplete = (inp, arr) => {
  /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
  var currentFocus;
  /*execute a function when someone writes in the text field:*/
  inp.addEventListener("input", function (e) {
    var a,
      b,
      i,
      val = this.value;
    /*close any already open lists of autocompleted values*/
    closeAllLists();
    if (!val) {
      return false;
    }
    currentFocus = -1;
    /*create a DIV element that will contain the items (values):*/
    a = document.createElement("DIV");
    a.setAttribute("id", this.id + "autocomplete-list");
    a.setAttribute("class", "autocomplete-items");
    /*append the DIV element as a child of the autocomplete container:*/
    this.parentNode.appendChild(a);
    /*for each item in the array...*/
    for (i = 0; i < arr.length; i++) {
      /*check if the item starts with the same letters as the text field value:*/
      if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
        /*create a DIV element for each matching element:*/
        b = document.createElement("DIV");
        /*make the matching letters bold:*/
        b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
        b.innerHTML += arr[i].substr(val.length);
        /*insert a input field that will hold the current array item's value:*/
        b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
        /*execute a function when someone clicks on the item value (DIV element):*/
        b.addEventListener("click", function (e) {
          /*insert the value for the autocomplete text field:*/
          inp.value = this.getElementsByTagName("input")[0].value;
          /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
          closeAllLists();
        });
        a.appendChild(b);
      }
    }
  });
  /*execute a function presses a key on the keyboard:*/
  inp.addEventListener("keydown", function (e) {
    var x = document.getElementById(this.id + "autocomplete-list");
    if (x) x = x.getElementsByTagName("div");
    if (e.keyCode == 40) {
      /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
      currentFocus++;
      /*and and make the current item more visible:*/
      addActive(x);
    } else if (e.keyCode == 38) {
      //up
      /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
      currentFocus--;
      /*and and make the current item more visible:*/
      addActive(x);
    } else if (e.keyCode == 13) {
      /*If the ENTER key is pressed, prevent the form from being submitted,*/
      e.preventDefault();
      if (currentFocus > -1) {
        /*and simulate a click on the "active" item:*/
        if (x) x[currentFocus].click();
      }
    }
  });
  function addActive(x) {
    /*a function to classify an item as "active":*/
    if (!x) return false;
    /*start by removing the "active" class on all items:*/
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = x.length - 1;
    /*add class "autocomplete-active":*/
    x[currentFocus].classList.add("autocomplete-active");
  }
  function removeActive(x) {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove("autocomplete-active");
    }
  }
  function closeAllLists(elmnt) {
    /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
    var x = document.getElementsByClassName("autocomplete-items");
    for (var i = 0; i < x.length; i++) {
      if (elmnt != x[i] && elmnt != inp) {
        x[i].parentNode.removeChild(x[i]);
      }
    }
  }
  /*execute a function when someone clicks in the document:*/
  document.addEventListener("click", function (e) {
    closeAllLists(e.target);
  });
};

// Fix for WordPress jQuery.
const $ = jQuery;

$(function () {
  $(".epl-sort-listings").selectize({
    onChange: function (value, isOnInitialize) {
      if (value !== "") {
        var url = window.location.href;
        var newUrl = updateQueryStringParameter(url, "sortby", value);
      }
      window.location.replace(newUrl);
    }
  });
});

// Once doc is loaded, do the stuff.
$(function () {
  // Enable Tooltips
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    tooltipTriggerEl => new understrap.Tooltip(tooltipTriggerEl)
  );

  Fancybox.bind('[data-fancybox="gallery"]', {
    on: {
      "*": (fancybox, eventName) => {
        console.log(`Fancybox eventName: ${eventName}`);
      }
    }
  });

  if (jQuery("#btnFetch").length) {
    jQuery("#btnFetch").on("click", function () {
      jQuery(this).html(
        '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Searching...'
      );
    });
  }

  if (jQuery("#PrimarySubmit").length) {
    jQuery("#PrimarySubmit").on("click", function () {
      jQuery(this).html(
        '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Searching...'
      );
      jQuery("#address_search").addClass("shorter-search");
    });
  }

  /**
     * selectize all select elements with default settings.
     */
  $(
    "select:not(.select-suburb, #nearby-suburbs-select, #suburb-profile-dropdown)"
  ).selectize({
    plugins: [
      "remove_button",
      "restore_on_backspace",
      "clear_button",
      "auto_position"
    ],
    delimiter: ",",
    persist: false,
    create: function (input) {
      return {
        value: input,
        text: input
      };
    },
    onInitialize: function () {
      var self = this;
      self.$control.on("click", function () {
        self.focus();
      });
    }
  });

  /**
     * Selectize the suburb select field.
     */
  $(".select-suburb").selectize({
    plugins: ["remove_button", "clear_button", "auto_position"],
    delimiter: ",",
    persist: false,
    onInitialize: function () {
      var self = this;
      self.$control.on("click", function () {
        self.focus();
      });
    }
  });

  /**
     * Smooth scroll to anchor link.
     */
  var hash = window.location.hash;
  hash && $('ul.nav a[href="' + hash + '"]').tab("show");

  $(".nav-tabs a").click(function (e) {
    $(this).tab("show");
    var scrollmem = $("body").scrollTop();
    window.location.hash = this.hash;
    $("html,body").scrollTop(scrollmem);
  });

  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 1) {
      $("#wrapper-navbar").addClass("scrolling");
    } else {
      $("#wrapper-navbar").removeClass("scrolling");
    }
  });

  // Override the default Google Map to be orange.
  overrideMap();

  /**
     * Tapi related scripts.
     * 
     */
  var tapi_elem = `</p><p></p><div class="tapi-embedded-request" data-company="88faf7ca-044c-45cb-9dcb-6fd324c56661" data-type="bot"></div><p></p><p>`;
  $("#modal-tapi-chat").on("show.bs.modal", function (event) {
    $(".tapi-container").html(tapi_elem);
    (function (d, id) {
      if (d.getElementById(id)) return;
      var js = d.createElement("script");
      js.id = id;
      js.src = "//tapi.app/js/embed.js";
      d.head.appendChild(js);
    })(document, "tapi-embed-js");
  });
  $("#modal-tapi-chat").on("hidden.bs.modal", function (event) {
    $("#tapi-container").html("");
    $("#tapi-embed-js").remove();
  });

  $(document).on("gform_page_loaded", function (event, formId, currentPage) {
    // If the form is the OC First form, then we need to selectize the select elements.
    if (currentPage == 2 && formId == 24) {
      var formID = "#gform_" + formId;
      $(formID + " select").selectize({
        plugins: [
          "remove_button",
          "restore_on_backspace",
          "clear_button",
          "auto_position"
        ],
        delimiter: ",",
        persist: false,
        create: function (input) {
          return {
            value: input,
            text: input
          };
        }
      });
    }
  });
});

/** Let's override the RMA swiper stuff. */
window.addEventListener("load", function () {
  [
    {
      selector: ".rma-full-review-carousel",
      config: { slidesPerView: 1, spaceBetween: 10, grabCursor: !0 }
    },
    {
      selector: ".rma-multi-slide-carousel",
      config: {
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: !0,
        breakpointsBase: "container",
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 10 },
          640: { slidesPerView: 2, spaceBetween: 10 },
          960: { slidesPerView: 3, spaceBetween: 20 },
          1200: { slidesPerView: 3, spaceBetween: 10 }
        }
      }
    }
  ].forEach(({ selector: e, config: i }) => {
    document.querySelectorAll(e).forEach(e =>
      ((e, i) => {
        const r = `#${e.id}`,
          s = `.${e.id}-container`,
          n = {
            ...i,
            navigation: {
              nextEl: `${s} .swiper-button-next`,
              prevEl: `${s} .swiper-button-prev`
            },
            pagination: { el: `${s} .swiper-pagination`, clickable: !0 }
          };
        new Swiper(r, n);
      })(e, i)
    );
  });
});

window.updateQueryStringParameter = (uri, key, value) => {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
};

window.initFancybox = () => {
  Fancybox.bind("[data-fancybox]", {});
};

window.checkState = element => {
  $(function () {
    document.getElementById(element).src =
      "/app/themes/ocre-child/media/placeholder.jpg";
  });
};

/**
 * Whole bunch of random BS.
 */
$("document").ready(function () {
  $("button.navbar-toggler").click(function () {
    console.log("clicked");
    var navbar_obj = $($(this).data("target"));
    navbar_obj.toggleClass("open");
  });

  removeEnterButtonListener();
  teamMemberList();
});

/**
 * Team Member List behavior
 */
const teamMemberList = () => {
  const mobileList = document.querySelectorAll(".team-mobile-list select");
  const allSubDropdown = document.querySelectorAll(".sub-dropdown");

  // Event listener for Dropdown
  mobileList.forEach(select => {
    select.addEventListener("change", e => {
      let option = e.target.options[e.target.selectedIndex];
      let selectTarget = option.dataset.select;
      let target = option.dataset.target;

      // Clear other sub dropdowns
      if (!select.classList.contains("sub-dropdown")) {
        allSubDropdown.forEach(sub => {
          if (!sub.classList.contains("d-none")) {
            sub.classList.add("d-none");
          }
        });
      }

      // For options with another dropdowns
      if (selectTarget) {
        let subdropdown = document.getElementById(selectTarget);
        let subdropdownSelection =
          subdropdown.options[subdropdown.selectedIndex];
        // Show targeted dropdown
        if (subdropdown.classList.contains("d-none")) {
          subdropdown.classList.remove("d-none");
        }

        // Do the tabs in bootstrap4
        $(subdropdownSelection).tab("show");
        // Change hash for page-reload
        // $(subdropdownSelection.dataset.target).on('shown.bs.tab', function (e) {
        //   window.location.hash = subdropdownSelection.dataset.target;
        // });
      }

      // For options with href
      if (option.dataset.href) {
        // window.location = option.dataset.href;
        window.open(option.dataset.href);
      }

      // Do the tabs in bootstrap4
      $(option).tab("show");
      // Change hash for page-reload
      // $(option).on('shown.bs.tab', function (e) {
      //   window.location.hash = target;
      // });
    });

    // ON load stuff, making sure options still shows when loading
    // let selectedIndex = select.options[select.selectedIndex].text;

    // if( selectedIndex == "Sales") {

    // }
  }); // end foreach
};

const removeEnterButtonListener = () => {
  let formList = ["gform_13", "gform_25", "gform_27", "gform_28", "gform_29"];

  formList.forEach(_form => {
    let ocForm = $("#" + _form);

    if (ocForm) {
      let btnSubmit = $(".gform_button");

      ocForm.bind("keypress", function (e) {
        if (e.keyCode == 13) {
          e.preventDefault();
          // btnSubmit.click();
          return false;
        }
      });
    }
  });
};

$(function () {
  //add BT DD show event
  $(".dropdown").on("show.bs.dropdown", function () {
    var btnDropDown = $(this).find(".dropdown-toggle");
    var listHolder = $(this).find(".dropdown-menu");
    //reset position property for DD container
    $(this).css("position", "static");
    listHolder.css({
      top: btnDropDown.offset().top + btnDropDown.outerHeight(true) + "px",
      left: btnDropDown.offset().left + "px"
    });
    listHolder.data("open", true);
  });
  //add BT DD hide event
  $(".dropdown").on("hidden.bs.dropdown", function () {
    var listHolder = $(this).find(".dropdown-menu");
    listHolder.data("open", false);
  });
  //add on scroll for table holder
  $(".ak-holder").scroll(function () {
    var ddHolder = $(this).find(".dropdown");
    var btnDropDown = $(this).find(".dropdown-toggle");
    var listHolder = $(this).find(".dropdown-menu");
    if (listHolder.data("open")) {
      listHolder.css({
        top: btnDropDown.offset().top + btnDropDown.outerHeight(true) + "px",
        left: btnDropDown.offset().left + "px"
      });
      ddHolder.toggleClass(
        "open",
        btnDropDown.offset().left > $(this).offset().left
      );
    }
  });
});

//Slick Slider
import { slick } from "slick-carousel";

//Add data attribute to Sign In link.
document.addEventListener("DOMContentLoaded", function () {
  var links = document.querySelectorAll('a[href="#sign-in"]');
  for (var i = 0; i < links.length; i++) {
    links[i].setAttribute("data-bs-toggle", "modal");
  }
});

//Trigger modal by hash on URL
document.addEventListener("DOMContentLoaded", function () {
  var hash = window.location.hash;
  if (hash) {
    var button = document.querySelector('[href="' + hash + '"]');
    if (button) {
      button.click();
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new understrap.Tooltip(tooltipTriggerEl));
});